import { render, staticRenderFns } from "./Order0etail.vue?vue&type=template&id=b63142a6&scoped=true"
import script from "./Order0etail.vue?vue&type=script&lang=js"
export * from "./Order0etail.vue?vue&type=script&lang=js"
import style0 from "./Order0etail.vue?vue&type=style&index=0&id=b63142a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63142a6",
  null
  
)

export default component.exports